// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1m9rI","boxTitle":"Qualiphy_boxTitle__3yIfz","box":"Qualiphy_box__RmR1a","toggleWrap":"Qualiphy_toggleWrap__1iHIR"};